import { useState } from 'react';
import { adminApi } from '../../api/endpoints.js';
import { useNotice } from '../../state/NoticeContext.jsx';
import { Button, Card, Muted, Select, Area, Text } from '../../ui.jsx';

export default function AdminBroadcast() {
  const notice = useNotice();
  const [form, setForm] = useState({ subject: '', body: '', status: 'All' });
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const set = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  const send = async (event) => {
    event.preventDefault();
    setBusy(true);
    setResult(null);
    try {
      const data = await adminApi.broadcast({
        subject: form.subject.trim(),
        body: form.body.trim(),
        status: form.status
      });
      setResult(data);
      notice.success(data.message);
      setForm({ subject: '', body: '', status: form.status });
    } catch (error) {
      notice.fromError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <h2>Message your applicants</h2>
      <Muted>
        Sends to the email address on each application you choose. Applicants are matched by
        application, not by a mailing list.
      </Muted>

      <form onSubmit={send}>
        <Card>
          <Text
            label="Subject"
            required
            value={form.subject}
            onChange={set('subject')}
          />
          <div style={{ height: 12 }} />
          <Area
            label="Message"
            required
            rows={8}
            hint="At least 10 characters. Write the same message to everyone in this group."
            value={form.body}
            onChange={set('body')}
          />
          <div style={{ height: 12 }} />
          <div style={{ maxWidth: 280 }}>
            <Select label="Who receives this" value={form.status} onChange={set('status')}>
              <option value="All">Everyone who has applied</option>
              <option value="submitted">Submitted, not yet reviewed</option>
              <option value="under_review">Under review</option>
              <option value="offered">Offered</option>
              <option value="rejected">Rejected</option>
            </Select>
          </div>
          <div style={{ marginTop: 16 }}>
            <Button type="submit" busy={busy}>Send message</Button>
          </div>
        </Card>
      </form>

      {result ? (
        <Card>
          <h3 style={{ fontSize: 18, margin: '0 0 8px' }}>Result</h3>
          <p className="mu">{result.message}</p>
          {result.failures?.length ? (
            <div className="note">
              <b>{result.failures.length} could not be delivered.</b>
              <div className="mu">{result.failures.join(', ')}</div>
            </div>
          ) : null}
        </Card>
      ) : null}
    </>
  );
}
